var render, staticRenderFns
import script from "./SignupBody.vue?vue&type=script&lang=js&"
export * from "./SignupBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19bcd64",
  null
  
)

export default component.exports